import MuiCheckbox from "@mui/material/Checkbox";
const Checkbox = MuiCheckbox;
export default Checkbox;
